import React, { useEffect, useState } from "react";
import {
  Form,
  Layout,
  Menu,
  Modal,
  Col,
  Row,
  Input,
  Button,
  Divider,
  Dropdown,
  Badge,
} from "antd";
import {
  UserOutlined,
  BellOutlined,
  LoginOutlined,
  KeyOutlined,
  MenuUnfoldOutlined,
  FileAddOutlined,
  ShareAltOutlined,
  DoubleRightOutlined,
  AreaChartOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  MenuFoldOutlined,
  TagOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import { checkTokenExpired, clearLocalStorage } from "../shared/authoration";
import "./Main.css";
import history from "../shared/history";
import API from "../shared/api/api";
import { Route, Switch, Link } from "react-router-dom";
import FowarderList from "../Modules/Fowarder/FowarderList/FowarderList";
import DriverList from "../Modules/Driver/DriverList/DriverList";
import OrderList from "../Modules/Order/PendingOrder/OrderList/OrderList";
import AssignVehicleDriver from "./../Modules/AssignVehicleDriver/AssignVehicleDriver";
import CreateDriver from "../Modules/Driver/CreateDriver/CreateDriver";
import DetailDriver from "../Modules/Driver/DetailDriver/DetailDriver";
import UpdateDriver from "../Modules/Driver/UpdateDriver/UpdateDriver";
import CreateForwarder from "../Modules/Fowarder/CreateForwarder/CreateForwarder";
import DetailForwarder from "../Modules/Fowarder/DetailForwarder/DetailForwarder";
import UpdateForwarder from "../Modules/Fowarder/UpdateForwarder/UpdateForwarder";
import ScreenOld from "../ScreenOld";
import DetailOrder from "../Modules/Order/PendingOrder/DetailOrder/DetailOrder";
import CreateOrder from "../Modules/Order/PendingOrder/CreateOrder/CreateOrder";
import UpdateOrder from "../Modules/Order/PendingOrder/UpdateOrder/UpdateOrder";
import {
  rule_max_character,
  rule_min_character,
  rule_require,
} from "../shared/validateInput";
import OrderWithRouteList from "../Modules/AssignRoute/OrderWithRouteList/OrderWithRouteList";
import PriceList from "../Modules/Price/PriceList/PriceList";
import PriceContractorList from "../Modules/Price/PriceContractorList/PriceContractorList";
import TrackingOrder from "../Modules/Tracking/TrackingOrder/TrackingOrder";
import CreateRoute from "../Modules/Route/CreateRoute/CreateRoute";
import CreateBasicRoute from "../Modules/Route/CreateBasicRoute/CreateBasicRoute";
import CreateAttributeRoute from "../Modules/Route/CreateAttributeRoute/CreateAttributeRoute";
import UpdateBasicRoute from "../Modules/Route/UpdateBasicRoute/UpdateBasicRoute";
import UpdateRouteWithPath from "../Modules/Route/UpdateRouteWithPath/UpdateRouteWithPath";
import UpdateRouteContractorWithPath from "../Modules/Route/UpdateRouteContractorWithPath/UpdateRouteContractorWithPath";
import AssignOrderVehicle from "../Modules/Order/AssignOrderVehicle/AssignOrderVehicle";
import AssignRouteTruckVendor from "../Modules/Route/AssignRouteTruckVendor/AssignRouteTruckVendor";
import ShippingOrderList from "../Modules/Order/ShippingOrder/ShippingOrderList/ShippingOrderList";
import ShippingOrderDetail from "../Modules/Order/ShippingOrder/ShippingOrderDetail/ShippingOrderDetail";
import HistoryOrder from "../Modules/Order/History/HistoryOrder";
import TrailerList from "../Modules/Trailer/TrailerList/TrailerList";
import TrailerCreate from "../Modules/Trailer/TrailerCreate/TrailerCreate";
import TrailerUpdate from "../Modules/Trailer/TrailerUpdate/TrailerUpdate";
import Dashboard from "../Modules/Dashboard/Dashboard";
import ShipList from "../Modules/Ship/ShipList";
import ShipCreate from "../Modules/Ship/CreateShip";
import ShipUpdate from "../Modules/Ship/UpdateShip";
import BotList from "../Modules/BOT/BotList/BotList";
import BotCreate from "../Modules/BOT/BotCreate/BotCreate";
import BotUpdate from "../Modules/BOT/BotUpdate/BotUpdate";
import SeaportList from "../Modules/Seaport/SeaportList";
import UpdateHistoryOrder from "../Modules/Order/History/UpdateHistoryOrder/UpdateHistoryOrder";
import CreateRouteWithPath from "../Modules/Route/CreateRouteWithPath";
import CreateRouteContractorWithPath from "../Modules/Route/CreateRouteContractorWithPath";
import PlacesList from "../Modules/Places/PlacesList";
import EditPlace from "../Modules/Places/EditPlace";
import CreatePlace from "../Modules/Places/CreatePlace";
import { GasStation } from "../Modules/GasStation/GasStation";
import { ConfigList } from "../Modules/Config/ConfigList";
import { MenuProps } from "antd/lib";
import stlyes from "./Main.module.scss";

import { useRecoilState } from "recoil";
import { UserApi } from "../services";

import Screen from "../Screen";
import Vehicle from "../Screen/Vehicle";
import Test from "../Screen/test";
import { Input as InputCustom } from "./DataEntry";
import { useRequestLock } from "../shared/hooks/useRequestLock";
const { Header, Content, Sider } = Layout;
const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};
import { useLocation, useHistory } from "react-router-dom";
import { UserAtom } from "../store";
import { set } from "lodash";

type MenuItem = Required<MenuProps>["items"][number];

const mockNotification = [
  {
    key: "1",
    label: "Notification 1",
  },
  {
    key: "2",
    label: "Notification 2",
  },
];

const Main = () => {
  //Define constant
  const [form] = Form.useForm();
  const { isLocked, runLocked } = useRequestLock();
  const changePasswordKey = "main:change-password";
  const isChangingPassword = isLocked(changePasswordKey);
  const logout = () => {
    clearLocalStorage();
    history.push("/login");
  };
  const locattion = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [userData, setUserData] = useState<any>({
    username: "Guest",
    position: "Guest",
  });

  const navigate = useHistory();
  const [permissions, setPermissions] = useRecoilState(UserAtom.permissions);

  //Funtion to create
  const getMyPermissions = async () => {
    const response = await UserApi.getMyPermissions().then((res) => res);
    if (response) {
      setPermissions(response);
    }
  };
  const getItem = (
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    type?: string,
    link?: string,
    children?: MenuItem[],
  ): MenuItem => {
    return {
      key,
      icon,
      children,
      type,
      link,
      label,
    } as MenuItem;
  };

  const items: MenuItem[] = [
    getItem("Dashboard", "1", <img src="/icon/home-outline.svg" />),
    getItem(
      "Vận hành",
      "operation",
      <img
        style={{ border: "1px solid black", borderRadius: "50%" }}
        src="/icon/operation-outline.svg"
      />,
    ),
    getItem(
      "Phương án kinh doanh",
      "business-plan",
      <img src="/icon/plane-outline.svg" />,
    ),
    getItem("Quản lý duyệt", "4", <img src="/icon/bank-outline.svg" />),
    getItem("Báo cáo", "5", <img src="/icon/check-outline.svg" />),
    getItem("Khác", "6", null, "group"),
    getItem("Cài đặt", "setting", <img src="/icon/setting.svg" />),
    getItem("Báo cáo", "8", <img src="/icon/check-outline.svg" />),
  ];

  //Funtion to handle action
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    await runLocked(changePasswordKey, async () => {
      const response = await API.post(
        "change-password",
        form.getFieldsValue(),
      ).then((res) => res.data);
      if (response.success) setIsModalVisible(false);
    });
  };

  const handleCancel = () => {
    if (isLocked(changePasswordKey)) return;
    setIsModalVisible(false);
  };
  const toggle = () => {
    setCollapsed(!collapsed);
  };
  let href = window.location.href.split("/");
  const styleContent = () => {
    if (href[3] == "statistic") {
      return {
        padding: 0,
        margin: 0,
        minHeight: 680,
      };
    }
    if (
      (href[3] == "order" && href[4] == "pending" && href[5] == "create") ||
      (href[3] == "order" && href[4] == "pending" && href[5] == "edit")
    ) {
      return {
        // padding: 14,
        margin: 0,
        minHeight: 680,
        backgroundColor: "#F0F2F5",
      };
    } else
      return {
        // padding: 14,
        margin: 0,
        minHeight: 680,
      };
  };
  //function to render
  const renderSiderBar = () => {
    return (
      <Sider
        width={250}
        trigger={null}
        collapsible={true}
        collapsed={collapsed}
        collapsedWidth={70}
        className={stlyes.customSider}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "25px 0",
          }}
        >
          <div>
            <a href="/operation">
              <img
                alt="logo"
                style={{ width: collapsed ? 30 : 180, position: "relative" }}
                src={collapsed ? "/icon/favicon.png" : "/icon/logo-sider.png"}
              />
            </a>
          </div>
        </div>
        <Menu
          mode="inline"
          style={{ height: "100%", borderRight: 0, width: "100%" }}
          theme="light"
          items={items}
          className={stlyes.customMenuSider}
          selectedKeys={[locattion.pathname.split("/")[1] ?? null]}
          onClick={(info) => history.push(`/${info.key}`)}
        />
      </Sider>
    );
  };

  const renderHeaderNotification = () => {
    return (
      <Dropdown
        menu={{ items: mockNotification }}
        trigger={["hover"]}
        placement="bottomRight"
      >
        <div style={{ cursor: "pointer", padding: "0 16px" }}>
          <Badge count={2} size="small">
            <BellOutlined style={{ fontSize: 20 }} />
          </Badge>
        </div>
      </Dropdown>
    );
  };

  const headerAccountItems = [
    {
      key: "1",
      label: "Thay đổi mật khẩu",
      icon: <KeyOutlined />,
      onClick: showModal,
    },
    {
      key: "2",
      label: "Đăng xuất",
      icon: <LoginOutlined />,
      onClick: logout,
    },
  ];
  const renderHeaderAccount = () => {
    return (
      <Dropdown
        menu={{ items: headerAccountItems }}
        trigger={["hover"]}
        placement="bottomRight"
      >
        <Row
          style={{ cursor: "pointer", padding: "0 16px", gap: "12px" }}
          align="middle"
        >
          <UserOutlined style={{ fontSize: "20px" }} />
          <div style={{ lineHeight: 1 }}>
            <div style={{ fontWeight: 700, marginBottom: "px" }}>
              {userData.username}
            </div>
            <div style={{ color: "#999", marginTop: "5px" }}>
              {userData.position}
            </div>
          </div>
          <DownOutlined style={{ fontSize: 14, color: "#888" }} />
        </Row>
      </Dropdown>
    );
  };
  const renderSearchMenu = () => {
    return (
      <Row align="middle">
        <InputCustom
          prefix={<SearchOutlined />}
          shaperound="true"
          style={{ background: "#F5F7F9", width: "400px" }}
          placeholder="Tìm kiếm"
        />
      </Row>
    );
  };
  const renderHeaderMenuRight = () => {
    return (
      <Row className={stlyes.HeaderMenuRight} align="middle">
        {renderSearchMenu()}
        {renderHeaderNotification()}
        <Divider type="vertical" style={{ width: "2px", height: "3.5em" }} />
        {renderHeaderAccount()}
      </Row>
    );
  };

  const renderHeader = () => {
    return (
      <Header
        className="header"
        style={{
          height: "70px",
        }}
      >
        <Row justify="space-between" align="middle" style={{ height: "100%" }}>
          <Button onClick={toggle}>
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </Button>
          {renderHeaderMenuRight()}
        </Row>
      </Header>
    );
  };

  const renderContent = () => {
    return (
      <Layout
        style={{
          padding: "10px",
          maxWidth: `calc(100vw - ${collapsed ? 70 : 250}px - 20px)`,
        }}
      >
        <Content className="site-layout-background" style={styleContent()}>
          <Switch>
            <Route exact path="/common/router-manager">
              <Screen.RouteManager />
            </Route>
            <Route exact path="/operation">
              <Screen.Operation />
            </Route>
            <Route exact path="/business-plan">
              <Screen.BusinessPlan />
            </Route>
            <Route exact path="/test">
              <Test />
            </Route>
            <Route exact path="/common/freight-revenue">
              <Screen.FreightRevenue />
            </Route>
            <Route exact path="/common/freight-costs">
              <Screen.FreightCosts />
            </Route>
            <Route exact path="/setting">
              <Screen.Setting />
            </Route>
            <Route exact path="/allocation-cost">
              <Screen.AllocationCost />
            </Route>

            <Route exact path="/common/vehicle">
              <Vehicle />
            </Route>

            <Route exact path="/common/customer">
              <Screen.Customer />
            </Route>

            <Route exact path="/common/contructor">
              <Screen.Contructor />
            </Route>

            <Route exact path="/operation/repair">
              <ScreenOld.Repair.RepairList />
            </Route>
            <Route exact path="/operation/repair/create">
              <ScreenOld.Repair.RepairCreate />
            </Route>
            <Route exact path="/operation/repair/:id/edit">
              <ScreenOld.Repair.RepairUpdate />
            </Route>

            <Route exact path="/operation/orders">
              <Screen.Orders />
            </Route>

            <Route exact path="/operation/incurred-costs">
              <Screen.IncurredCosts />
            </Route>

            <Route exact path="/operation/trip-closing">
              <Screen.TripClosing />
            </Route>

            <Route exact path="/operation/data-locks">
              <Screen.DataLock />
            </Route>

            <Route exact path="/operation/oil">
              <ScreenOld.Oil.Oil />
            </Route>

            <Route exact path="/report/report-list">
              <Screen.Reports />
            </Route>
            {/* <Route exact path="/common/assign/vehicle/driver">
              <AssignVehicleDriver />
            </Route> */}
            {/* <Route exact path="/partner/forwarder">
                <FowarderList />
              </Route>
              <Route exact path="/partner/forwarder/create">
                <CreateForwarder />
              </Route>
              <Route exact path="/partner/forwarder/detail/:id">
                <DetailForwarder />
              </Route>
              <Route exact path="/partner/forwarder/edit/:id">
                <UpdateForwarder />
              </Route>

              <Route exact path="/partner/truck-vendor">
                <TruckVendorList />
              </Route>
              <Route exact path="/partner/truck-vendor/detail/:id">
                <DetailVendor />
              </Route>
              <Route exact path="/partner/truck-vendor/edit/:id">
                <UpdateVendor />
              </Route>
              <Route exact path="/partner/truck-vendor/create">
                <CreateVendor />
              </Route>

              <Route exact path="/resource/driver">
                <DriverList />
              </Route>
              <Route exact path="/resource/driver/create">
                <CreateDriver />
              </Route>
              <Route exact path="/resource/driver/detail/:id">
                <DetailDriver />
              </Route>
              <Route exact path="/resource/driver/edit/:id">
                <UpdateDriver />
              </Route>


              <Route exact path="/resource/trailer">
                <TrailerList />
              </Route>
              <Route exact path="/resource/trailer/create">
                <TrailerCreate />
              </Route>
              <Route exact path="/resource/trailer/edit/:id">
                <TrailerUpdate />
              </Route>

              <Route exact path="/order/pending">
                <OrderList />
              </Route>
              <Route exact path="/pending-order/detail/:id">
                <DetailOrder />
              </Route>
              <Route exact path="/order/pending/create">
                <CreateOrder />
              </Route>
              <Route exact path="/order/pending/edit/:id">
                <UpdateOrder />
              </Route>
              <Route exact path="/order/assign/vehicle">
                <AssignOrderVehicle />
              </Route>
              <Route exact path="/order/shipping">
                <ShippingOrderList />
              </Route>
              <Route exact path="/order/shipping/:id">
                <ShippingOrderDetail />
              </Route>
              <Route exact path="/order/history">
                <HistoryOrder />
              </Route>
              <Route exact path="/order/history/edit/:id">
                <UpdateHistoryOrder />
              </Route>

              <Route exact path="/setting/price">
                <PriceList />
              </Route>
              <Route exact path="/setting/config">
                <ConfigList />
              </Route>
              <Route exact path="/setting/priceContractor">
                <PriceContractorList />
              </Route>
              <Route exact path="/route/order/:id/create">
                <CreateRoute />
              </Route>
              <Route exact path="/basic-route/create">
                <CreateBasicRoute />
              </Route>
              <Route exact path="/route-with-path/create">
                <CreateRouteWithPath />
              </Route>
              <Route exact path="/route-contractor-with-path/create">
                <CreateRouteContractorWithPath />
              </Route>
              <Route exact path="/basic-route/edit/:id">
                <UpdateBasicRoute />
              </Route>
              <Route exact path="/route-with-path/edit/:id">
                <UpdateRouteWithPath />
              </Route>
              <Route exact path="/route-contractor-with-path/edit/:id">
                <UpdateRouteContractorWithPath />
              </Route>
              <Route exact path="/attribute-route/create">
                <CreateAttributeRoute />
              </Route>

              <Route exact path="/order/assign/route">
                <OrderWithRouteList />
              </Route>
              <Route
                exact
                path="/assign/order/:orderid/route/:routeid/truck-vendor"
              >
                <AssignRouteTruckVendor />
              </Route>

              <Route exact path="/tracking/order">
                <TrackingOrder />
              </Route>
              <Route exact path="/statistic">
                <Dashboard />
              </Route>


              <Route exact path="/partner/ship">
                <ShipList />
              </Route>
              <Route exact path="/partner/ship/create">
                <ShipCreate />
              </Route>
              <Route exact path="/partner/ship/:id/edit">
                <ShipUpdate />
              </Route>

              <Route exact path="/partner/bot">
                <BotList />
              </Route>
              <Route exact path="/place/all">
                <PlacesList />
              </Route>
              <Route exact path="/place/create">
                <CreatePlace />
              </Route>
              <Route exact path="/place/:id/edit">
                <EditPlace />
              </Route>
              <Route exact path="/partner/bot/create">
                <BotCreate />
              </Route>
              <Route exact path="/partner/bot/:id/edit">
                <BotUpdate />
              </Route>
              <Route exact path="/partner/seaport">
                <SeaportList />
              </Route>
              <Route exact path="/manager/gas-station">
                <GasStation />
              </Route> */}
          </Switch>
        </Content>
      </Layout>
    );
  };

  const renderModal = () => {
    return (
      <Modal
        title="Thay đổi mật khẩu"
        open={isModalVisible}
        confirmLoading={isChangingPassword}
        closable={!isChangingPassword}
        maskClosable={!isChangingPassword}
        keyboard={!isChangingPassword}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ disabled: isChangingPassword }}
        cancelButtonProps={{ disabled: isChangingPassword }}
      >
        <Row style={{ width: "100%" }}>
          <Form form={form} {...layout} style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                label="Mật khẩu cũ"
                name="oldPassword"
                rules={[rule_require, rule_min_character, rule_max_character]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                label="Mật khẩu mới"
                name="newPassword"
                rules={[rule_require, rule_min_character, rule_max_character]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                label="Nhập lại mật khẩu mới"
                name="repeatNewPassword"
                rules={[rule_require, rule_min_character, rule_max_character]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Form>
        </Row>
      </Modal>
    );
  };
  //Function to effect
  useEffect(() => {
    checkTokenExpired() && getMyPermissions();
    if (typeof window != "undefined") {
      setUserData(JSON.parse(localStorage.getItem("user") ?? "{}"));
    }
  }, []);
  //main render
  return (
    <Layout style={{ minHeight: "100vh" }}>
      {renderModal()}
      <Layout>
        {renderSiderBar()}
        <div style={{ width: "100%" }}>
          {renderHeader()}
          {renderContent()}
        </div>
      </Layout>
    </Layout>
  );
};

export default Main;
